import React from 'react';
import { Field } from 'redux-form';
import { Strings } from '../../../dataProvider/localize';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { notification } from 'antd';
import { reduxForm } from 'redux-form';
import * as action from '../../../actions/organizationUserAction';
import { customInput } from '../../common/custom-input';
import { CustomSelect } from '../../common/customSelect';
import { countryCodes } from '../../../dataProvider/countryCodes';
import validator from 'validator';
import { ValidationStrings } from './../../../dataProvider/localize'
import { DeepTrim } from '../../../utils/common';
import {VALIDATE_STATUS} from '../../../dataProvider/constant';

let countryCode = '+61'

const required = value => value ? undefined : ValidationStrings.update_single_user_validation_name
//const phoneRequired = value => value ? (validator.isMobilePhone(value, ['en-IN', 'en-AU'])) ? undefined : ValidationStrings.update_single_user_validation_invalid_phone_number : ValidationStrings.update_single_user_validation_phone_number
const emailRequired = value => value ? (validator.isEmail(value, ['en-IN', 'en-AU'])) ? undefined : ValidationStrings.update_single_user_validation_invalid_email_address : ValidationStrings.update_single_user_validation_email_address
const selectRole = value => value ? undefined : ValidationStrings.update_single_user_validation_role

class UpdateSingleUser extends React.Component {

  phoneRequired = value => {
    if (!value) {
      return 'Enter phone number'
    } else if (!validator.isMobilePhone(countryCode + value, 'any')) {
      return 'Invalid phone number'
    }
    return undefined
  }

  onSubmit = async (formData) => {
    formData = await DeepTrim(formData);

    this.props.updateUsersFromView({ org_user: formData }, formData.organisation_id)
      .then((flag) => {
        this.props.reset();
        this.props.removeInlineUser(this.props.initialValues);
      })
      .catch((error) => {
        if (error.status === VALIDATE_STATUS) {
          notification.warning({
            message: Strings.validate_title,
            description: error && error.data && typeof error.data.message === 'string'
              ? error.data.message : Strings.generic_validate,
            onClick: () => { },
            className: 'ant-warning'
          });
        } else {
          notification.error({
            message: Strings.error_title,
            description: error && error.data && error.data.message && typeof error.data.message === 'string'
              ? error.data.message : Strings.generic_error,
            onClick: () => { },
            className: 'ant-error'
          });
        }
      });

  }

  componentDidMount() {
    if (this.props.initialValues && this.props.initialValues.country_code) {
      console.log(this.props.initialValues.country_code)
      countryCode = this.props.initialValues.country_code
    }
  }

  onSelectCountryCode = value => {
    countryCode = value
  }

  render() {

    const { handleSubmit, initialValues } = this.props;

    return (
      <form className="tr" onSubmit={handleSubmit(this.onSubmit)} key={initialValues.id}>
        <span className="td">
          <fieldset className="sf-form">
            <Field
              name={`name`}
              type="text"
              placeholder={Strings.name_user_org}
              validate={required}
              component={customInput}
            />
          </fieldset>
        </span>
        <span className="td">
          <fieldset className="sf-form">
            <Field
              name={`email_address`}
              type="text"
              placeholder={Strings.email_address_org}
              validate={emailRequired}
              component={customInput}
            />
          </fieldset>
        </span>
        <span className="td">
          <div className="co-code-mobile-no">
            <fieldset className="sf-form co-code-txt">
              <Field
                name={`country_code`}
                type="text"
                showSearch={1}
                options={countryCodes.map(country => ({
                  title: country.dial_code,
                  value: country.dial_code
                }))}
                component={CustomSelect}
                onChange={this.onSelectCountryCode}
              />
            </fieldset>
            <fieldset className="sf-form mobile-ntxt">
              <Field
                name={`phone_number`}
                type="text"
                maxLength="10"
                placeholder={Strings.phone_number_user_org}
                validate={this.phoneRequired}
                component={customInput}
              />
            </fieldset>
          </div>
        </span>
        <span className="td">
          <fieldset className="sf-form">
            <Field
              name={`role_id`}
              type="text"
              options={this.props.roles ? this.props.roles.map(role => ({ title: role.name, value: role.id })) : []}
              component={CustomSelect}
              validate={selectRole}
              placeholder={Strings.user_role_placeholder} />
          </fieldset>
        </span>
        <span className="td">
          <button className='delete-bnt' type='submit' >
            <i className="material-icons">save</i>
          </button>
          <button className='delete-bnt' type='button' onClick={() => this.props.removeInlineUser(this.props.initialValues)} >
            <i className="material-icons">close</i>
          </button>
        </span>
      </form>

    )
  }
}

const mapStateToProps = (state, { serviceObject }) => {
  return {
    roles: state.roleManagement.roles,
  }
}


export default compose(
  connect(mapStateToProps, action),
  reduxForm({ /*  validate, */ enableReinitialize: true })
)(UpdateSingleUser)
